import React from "react";
import JsqTermsOfUse from "./JsqTermsOfUse";
import LegacyJsqTermsOfUse from "./LegacyTermsOfUse";
import JsqPrivacyPolicy from "./JsqPrivacyPolicy";

export const jsqTermsOfUse = (
  hostname: string,
  origin: string,
  token: string,
  isUnifiedPortal: boolean,
) => {
  // Legacy TOU can be removed once institutional reporting support is no longer needed
  const TermsOfUse = isUnifiedPortal ? JsqTermsOfUse : LegacyJsqTermsOfUse;
  return <TermsOfUse hostname={hostname} origin={origin} token={token} />;
};

export const jsqPrivacyPolicy = <JsqPrivacyPolicy />;
